import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const notificationService = {
  // Get notifications with optional filters
  getNotifications: async (onlyUnread = false, limit = 20, page = 1) => {
    return await axios.get(`${API_URL}/notifications`, {
      params: { onlyUnread, limit, page },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
  },
  
  // Mark a notification as read
  markAsRead: async (id) => {
    return await axios.put(`${API_URL}/notifications/${id}/read`, {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
  },
  
  // Mark all notifications as read
  markAllAsRead: async () => {
    return await axios.put(`${API_URL}/notifications/read-all`, {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
  },
  
  // Delete a notification
  deleteNotification: async (id) => {
    return await axios.delete(`${API_URL}/notifications/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
  }
};

export default notificationService;